import { Injectable, inject, signal } from '@angular/core';
import { Language } from '../models/language.model';
import { UserService } from '../../services/user.service';

const PT: Record<string, string> = {
   Loyalty: 'Fidelidade',
   Welcome: 'Bem-vindo',
   Email: 'E-mail',
   Password: 'Senha',
   ForgotMyPassword: 'Esqueceu a senha?',
   LogIn: 'Entrar',
   NoAccount: 'Não tem conta?',
   SignUp: 'Cadastre-se',
   CreateAccount: 'Criar conta',
   AddPhoto: 'Adicionar foto',
   FullName: 'Nome completo',
   Document: 'CPF ou CNPJ',
   DocumentNumber: 'CPF/CNPJ',
   CellPhone: 'Celular',
   ConfirmPassword: 'Confirmar senha',
   PasswordRequirements: 'Requisitos da senha:',
   Min8Chars: 'Mínimo de 8 caracteres',
   OneUppercase: 'Uma letra maiúscula',
   OneNumber: 'Um número',
   OneSpecial: 'Um caractere especial',
   HasAccount: 'Já tem conta?',
   Home: 'Início',
   Companies: 'Empresas',
   Benefits: 'Benefícios',
   Profile: 'Perfil',
   Hello: 'Olá, {0} 👋',
   BenefitsUpdated: 'Seus benefícios estão atualizados!',
   ConsolidatedBalance: 'Saldo Consolidado',
   AccumulatedCashback: 'cashback acumulado',
   TotalPoints: 'pontos totais',
   CompaniesWithBalance: 'Você possui cashback/pontos nestas empresas',
   RecentHistory: 'Histórico recente',
   CompaniesSubtitle: 'Acompanhe seus programas de fidelidade ativos',
   SearchCompany: 'Buscar empresa parceira...',
   AvailableBalance: 'Saldo Disponível',
   AvailableCashback: 'cashback disponível',
   History: 'Histórico',
   Rewards: 'Recompensas',
   Redeem: 'Resgatar',
   Redeeming: 'Resgatando...',
   RequiredPoints: '{0} pontos',
   YourBenefits: 'Seus Benefícios',
   CheckWhatYouAccumulated: 'Confira tudo o que você acumulou',
   All: 'Todos',
   Cashback: 'Cashback',
   Points: 'Pontos',
   AvailableRewards: 'Recompensas disponíveis',
   PersonalData: 'Dados pessoais',
   Settings: 'Configurações',
   Logout: 'Sair',
   MemberSince: 'Membro desde {0}',
   Name: 'Nome',
   ChangePassword: 'Alterar senha',
   SaveChanges: 'Salvar alterações',
   CurrentPassword: 'Senha atual',
   NewPassword: 'Nova senha',
   ConfirmNewPassword: 'Confirmar nova senha',
   Language: 'Idioma',
   Theme: 'Tema',
   Light: 'Claro',
   Dark: 'Escuro',
   FontSize: 'Tamanho da fonte',
   LoggingIn: 'Entrando...',
   CreatingAccount: 'Criando conta...',
   ValidateMessageRequired: 'Campo obrigatório',
   EmailNotValid: 'E-mail inválido',
   ValidateMessageMinLengthRequired: 'Quantidade mínima de caracteres não atingida',
   ValidateMessageMaxLengthRequired: 'Quantidade máxima de caracteres excedida',
   PasswordConfirmationNotMatch: 'As senhas não coincidem',
   Redemptions: 'Resgates',
   RedemptionsSubtitle: 'Acompanhe seus resgates realizados',
   ActiveRedemptions: 'Resgates ativos',
   PastRedemptions: 'Resgates anteriores',
   NoRedemptions: 'Nenhum resgate realizado',
   OpenRoute: 'Abrir rota no GPS',
   CancelRedemption: 'Cancelar resgate',
   CancellingRedemption: 'Cancelando...',
   RedemptionDetail: 'Detalhe do resgate',
   Product: 'Produto',
   AdditionalInformation: 'Informação adicional',
   SeeMore: 'Ver mais',
   HistoryDetail: 'Detalhe do lançamento',
   AmountEarned: 'Valor ganho',
   AmountSpent: 'Valor utilizado',
   NoHistoryAvailable: 'Não há histórico disponível',
   NoRewardsAvailable: 'Não há recompensas disponíveis',
   NoCompaniesAvailable: 'Não há empresas disponíveis',
   NoCompaniesFound: 'Nenhuma empresa encontrada',
   RedemptionSuccessful: 'Resgate realizado com sucesso!',
   RedirectingToRedemptions: 'Em instantes você será redirecionado para acompanhar seus resgates.',
   MadeBy: 'Feito por',
   LoggingInWait: 'Entrando, aguarde...',
   SendingPasswordReset: 'Enviando e-mail de redefinição...',
   SavingChanges: 'Salvando alterações...',
   PasswordReset: 'Redefinição de senha',
   YouHaveReceivedAnEmailForPasswordReset: 'Se a conta com o e-mail {0} existir, enviaremos um e-mail com o link para redefinir sua senha.',
   ServiceConnectionFailed: 'Não foi possível conectar ao serviço.',
   AccountTemporarilyLocked: 'Conta temporariamente bloqueada. Tente novamente em instantes.',
   LoginTemporarilyUnavailable: 'Login temporariamente indisponível.',
   InvalidEmailOrPassword: 'E-mail ou senha inválidos.',
   OperationFailed: 'Não foi possível concluir a operação.',
   RewardUnavailable: 'Produto indisponível para resgate.',
   NotEnoughPoints: 'Pontos insuficientes para resgate.',
   RedemptionCannotCancel: 'Resgate indisponível para cancelamento.',
   OperationSuccessful: 'Operação realizada com sucesso.',
   TooManyAttempts: 'Muitas tentativas. Tente novamente em instantes.',
   RegistrationTemporarilyUnavailable: 'Cadastro temporariamente indisponível.',
   CouldNotCreateAccount: 'Não foi possível criar a conta.',
   ConfirmYourEmail: 'Confirme seu e-mail',
   EnterTheCodeThatWasSentTo: 'Enviamos um e-mail para {0}. Confirme para ativar sua conta.',
   ResendCode: 'Reenviar e-mail',
   ResendCodeTime: 'Reenviar em {0}s',
   Resending: 'Reenviando...',
   ResendEmailFailed: 'Não foi possível reenviar o e-mail.',
   ConfirmingEmail: 'Confirmando e-mail',
   ConfirmingEmailWait: 'Estamos confirmando seu e-mail, aguarde...',
   EmailConfirmed: 'E-mail confirmado',
   EmailConfirmedMessage: 'Sua conta foi ativada. Faça login para continuar.',
   EmailConfirmFailed: 'Não foi possível confirmar o e-mail',
   EmailConfirmLinkInvalid: 'O link de confirmação é inválido ou expirou.',
   Back: 'Voltar',
   PasswordResetTitle: 'Redefinir senha',
   PasswordResetInstruct: 'Informe sua nova senha.',
   PasswordChanged: 'Senha alterada',
   PasswordChangedMessage: 'Sua senha foi redefinida. Faça login para continuar.',
   PasswordChangeFailed: 'Não foi possível alterar a senha',
   PasswordResetLinkInvalid: 'O link de redefinição é inválido ou expirou.',
   SaveNewPassword: 'Salvar nova senha',
   ChangeMadeSuccessfully: 'Alteração realizada com sucesso.',
   TryAgain: 'Tente novamente.',
   CouldNotLoadData: 'Não foi possível carregar os dados.',
   FullNameInvalid: 'Informe nome e sobrenome.',
   PhoneNumberInvalid: 'Celular inválido.',
   DocumentInvalid: 'CPF ou CNPJ inválido.',
   CropPhoto: 'Ajustar foto',
   CropPhotoHint: 'Mova e ajuste a área da foto.',
   Cancel: 'Cancelar',
   Apply: 'Aplicar',
   ErrorLoadingImage: 'Não foi possível carregar a imagem.',
   ImageTooLarge: 'A imagem deve ter no máximo 4 MB.',
   InvalidImageType: 'Selecione um arquivo de imagem válido.',
   InstallApp: 'Instalar aplicativo',
   InstallAppHint: 'Acesse mais rápido, direto da tela inicial.',
   Install: 'Instalar',
   NotNow: 'Agora não',
   AddToHomeScreen: 'Já adicionei à tela inicial',
   InstallIosHint: 'No Safari, toque em Compartilhar e depois em Adicionar à Tela de Início.',
};

const EN: Record<string, string> = {
   ...PT,
   Loyalty: 'Loyalty',
   Welcome: 'Welcome',
   Password: 'Password',
   ForgotMyPassword: 'Forgot password?',
   LogIn: 'Sign in',
   NoAccount: "Don't have an account?",
   SignUp: 'Sign up',
   CreateAccount: 'Create account',
   AddPhoto: 'Add photo',
   FullName: 'Full name',
   CellPhone: 'Mobile',
   ConfirmPassword: 'Confirm password',
   PasswordRequirements: 'Password requirements:',
   Min8Chars: 'At least 8 characters',
   OneUppercase: 'One uppercase letter',
   OneNumber: 'One number',
   OneSpecial: 'One special character',
   HasAccount: 'Already have an account?',
   Home: 'Home',
   Companies: 'Companies',
   Benefits: 'Benefits',
   Profile: 'Profile',
   Hello: 'Hi, {0} 👋',
   BenefitsUpdated: 'Your benefits are up to date!',
   ConsolidatedBalance: 'Consolidated balance',
   AccumulatedCashback: 'accumulated cashback',
   TotalPoints: 'total points',
   CompaniesWithBalance: 'You have cashback/points at these companies',
   RecentHistory: 'Recent history',
   CompaniesSubtitle: 'Track your active loyalty programs',
   SearchCompany: 'Search partner company...',
   AvailableBalance: 'Available balance',
   AvailableCashback: 'available cashback',
   History: 'History',
   Rewards: 'Rewards',
   Redeem: 'Redeem',
   Redeeming: 'Redeeming...',
   RequiredPoints: '{0} points',
   YourBenefits: 'Your benefits',
   CheckWhatYouAccumulated: 'See everything you have earned',
   All: 'All',
   Points: 'Points',
   AvailableRewards: 'Available rewards',
   PersonalData: 'Personal data',
   Settings: 'Settings',
   Logout: 'Sign out',
   MemberSince: 'Member since {0}',
   Name: 'Name',
   ChangePassword: 'Change password',
   SaveChanges: 'Save changes',
   CurrentPassword: 'Current password',
   NewPassword: 'New password',
   ConfirmNewPassword: 'Confirm new password',
   Language: 'Language',
   Theme: 'Theme',
   Light: 'Light',
   Dark: 'Dark',
   FontSize: 'Font size',
   LoggingIn: 'Signing in...',
   CreatingAccount: 'Creating account...',
   ValidateMessageRequired: 'Required field',
   EmailNotValid: 'Invalid email',
   ValidateMessageMinLengthRequired: 'Minimum length not reached',
   ValidateMessageMaxLengthRequired: 'Maximum length exceeded',
   PasswordConfirmationNotMatch: 'Passwords do not match',
   Redemptions: 'Redemptions',
   RedemptionsSubtitle: 'Track your completed redemptions',
   ActiveRedemptions: 'Active redemptions',
   PastRedemptions: 'Past redemptions',
   NoRedemptions: 'No redemptions yet',
   OpenRoute: 'Open GPS route',
   CancelRedemption: 'Cancel redemption',
   CancellingRedemption: 'Cancelling...',
   RedemptionDetail: 'Redemption detail',
   Product: 'Product',
   AdditionalInformation: 'Additional information',
   SeeMore: 'See more',
   HistoryDetail: 'Entry detail',
   AmountEarned: 'Amount earned',
   AmountSpent: 'Amount used',
   NoHistoryAvailable: 'No history available',
   NoRewardsAvailable: 'No rewards available',
   NoCompaniesAvailable: 'No companies available',
   NoCompaniesFound: 'No companies found',
   RedemptionSuccessful: 'Redemption completed successfully!',
   RedirectingToRedemptions: 'In a moment you will be redirected to track your redemptions.',
   MadeBy: 'Made by',
   LoggingInWait: 'Signing in, please wait...',
   SendingPasswordReset: 'Sending password reset email...',
   SavingChanges: 'Saving changes...',
   PasswordReset: 'Password reset',
   YouHaveReceivedAnEmailForPasswordReset: 'If an account with the email {0} exists, we will send an email with a link to reset your password.',
   ServiceConnectionFailed: 'Could not connect to the service.',
   AccountTemporarilyLocked: 'Account temporarily locked. Try again shortly.',
   LoginTemporarilyUnavailable: 'Login temporarily unavailable.',
   InvalidEmailOrPassword: 'Invalid email or password.',
   OperationFailed: 'Could not complete the operation.',
   RewardUnavailable: 'This reward is not available for redemption.',
   NotEnoughPoints: 'Not enough points to redeem this reward.',
   RedemptionCannotCancel: 'This redemption cannot be cancelled.',
   OperationSuccessful: 'Operation completed successfully.',
   TooManyAttempts: 'Too many attempts. Try again shortly.',
   RegistrationTemporarilyUnavailable: 'Registration temporarily unavailable.',
   CouldNotCreateAccount: 'Could not create the account.',
   ConfirmYourEmail: 'Confirm your email',
   EnterTheCodeThatWasSentTo: 'We sent an email to {0}. Confirm it to activate your account.',
   ResendCode: 'Resend email',
   ResendCodeTime: 'Resend in {0}s',
   Resending: 'Resending...',
   ResendEmailFailed: 'Could not resend the email.',
   ConfirmingEmail: 'Confirming email',
   ConfirmingEmailWait: 'We are confirming your email, please wait...',
   EmailConfirmed: 'Email confirmed',
   EmailConfirmedMessage: 'Your account is active. Sign in to continue.',
   EmailConfirmFailed: 'Could not confirm the email',
   EmailConfirmLinkInvalid: 'The confirmation link is invalid or has expired.',
   Back: 'Back',
   PasswordResetTitle: 'Reset password',
   PasswordResetInstruct: 'Enter your new password.',
   PasswordChanged: 'Password changed',
   PasswordChangedMessage: 'Your password was reset. Sign in to continue.',
   PasswordChangeFailed: 'Could not change the password',
   PasswordResetLinkInvalid: 'The reset link is invalid or has expired.',
   SaveNewPassword: 'Save new password',
   ChangeMadeSuccessfully: 'Changes saved successfully.',
   TryAgain: 'Try again.',
   CouldNotLoadData: 'Could not load the data.',
   FullNameInvalid: 'Enter first and last name.',
   PhoneNumberInvalid: 'Invalid mobile number.',
   DocumentInvalid: 'Invalid CPF or CNPJ.',
   CropPhoto: 'Adjust photo',
   CropPhotoHint: 'Move and adjust the photo area.',
   Cancel: 'Cancel',
   Apply: 'Apply',
   ErrorLoadingImage: 'Could not load the image.',
   ImageTooLarge: 'The image must be 4 MB or smaller.',
   InvalidImageType: 'Select a valid image file.',
   InstallApp: 'Install app',
   InstallAppHint: 'Open it faster, right from your home screen.',
   Install: 'Install',
   NotNow: 'Not now',
   AddToHomeScreen: 'I already added it to my home screen',
   InstallIosHint: 'In Safari, tap Share and then Add to Home Screen.',
};

const ES: Record<string, string> = {
   ...PT,
   Loyalty: 'Fidelidad',
   Welcome: 'Bienvenido',
   Password: 'Contraseña',
   ForgotMyPassword: '¿Olvidaste tu contraseña?',
   LogIn: 'Entrar',
   NoAccount: '¿No tienes cuenta?',
   SignUp: 'Regístrate',
   CreateAccount: 'Crear cuenta',
   AddPhoto: 'Agregar foto',
   FullName: 'Nombre completo',
   CellPhone: 'Celular',
   ConfirmPassword: 'Confirmar contraseña',
   PasswordRequirements: 'Requisitos de la contraseña:',
   Min8Chars: 'Mínimo de 8 caracteres',
   OneUppercase: 'Una letra mayúscula',
   OneNumber: 'Un número',
   OneSpecial: 'Un carácter especial',
   HasAccount: '¿Ya tienes cuenta?',
   Home: 'Inicio',
   Companies: 'Empresas',
   Benefits: 'Beneficios',
   Profile: 'Perfil',
   Hello: 'Hola, {0} 👋',
   BenefitsUpdated: '¡Tus beneficios están actualizados!',
   ConsolidatedBalance: 'Saldo consolidado',
   AccumulatedCashback: 'cashback acumulado',
   TotalPoints: 'puntos totales',
   CompaniesWithBalance: 'Tienes cashback/puntos en estas empresas',
   RecentHistory: 'Historial reciente',
   CompaniesSubtitle: 'Sigue tus programas de fidelidad activos',
   SearchCompany: 'Buscar empresa socia...',
   AvailableBalance: 'Saldo disponible',
   AvailableCashback: 'cashback disponible',
   History: 'Historial',
   Rewards: 'Recompensas',
   Redeem: 'Canjear',
   Redeeming: 'Canjeando...',
   RequiredPoints: '{0} puntos',
   YourBenefits: 'Tus beneficios',
   CheckWhatYouAccumulated: 'Consulta todo lo que acumulaste',
   All: 'Todos',
   Points: 'Puntos',
   AvailableRewards: 'Recompensas disponibles',
   PersonalData: 'Datos personales',
   Settings: 'Configuración',
   Logout: 'Salir',
   MemberSince: 'Miembro desde {0}',
   Name: 'Nombre',
   ChangePassword: 'Cambiar contraseña',
   SaveChanges: 'Guardar cambios',
   CurrentPassword: 'Contraseña actual',
   NewPassword: 'Nueva contraseña',
   ConfirmNewPassword: 'Confirmar nueva contraseña',
   Language: 'Idioma',
   Theme: 'Tema',
   Light: 'Claro',
   Dark: 'Oscuro',
   FontSize: 'Tamaño de fuente',
   LoggingIn: 'Entrando...',
   CreatingAccount: 'Creando cuenta...',
   ValidateMessageRequired: 'Campo obligatorio',
   EmailNotValid: 'Correo inválido',
   ValidateMessageMinLengthRequired: 'Longitud mínima no alcanzada',
   ValidateMessageMaxLengthRequired: 'Longitud máxima excedida',
   PasswordConfirmationNotMatch: 'Las contraseñas no coinciden',
   Redemptions: 'Canjes',
   RedemptionsSubtitle: 'Sigue tus canjes realizados',
   ActiveRedemptions: 'Canjes activos',
   PastRedemptions: 'Canjes anteriores',
   NoRedemptions: 'Ningún canje realizado',
   OpenRoute: 'Abrir ruta en GPS',
   CancelRedemption: 'Cancelar canje',
   CancellingRedemption: 'Cancelando...',
   RedemptionDetail: 'Detalle del canje',
   Product: 'Producto',
   AdditionalInformation: 'Información adicional',
   SeeMore: 'Ver más',
   HistoryDetail: 'Detalle del movimiento',
   AmountEarned: 'Valor ganado',
   AmountSpent: 'Valor utilizado',
   NoHistoryAvailable: 'No hay historial disponible',
   NoRewardsAvailable: 'No hay recompensas disponibles',
   NoCompaniesAvailable: 'No hay empresas disponibles',
   NoCompaniesFound: 'Ninguna empresa encontrada',
   RedemptionSuccessful: '¡Canje realizado con éxito!',
   RedirectingToRedemptions: 'En unos instantes serás redirigido para seguir tus canjes.',
   MadeBy: 'Hecho por',
   LoggingInWait: 'Entrando, espera...',
   SendingPasswordReset: 'Enviando correo de restablecimiento...',
   SavingChanges: 'Guardando cambios...',
   PasswordReset: 'Restablecer contraseña',
   YouHaveReceivedAnEmailForPasswordReset: 'Si la cuenta con el correo {0} existe, enviaremos un correo con el enlace para restablecer tu contraseña.',
   ServiceConnectionFailed: 'No fue posible conectar con el servicio.',
   AccountTemporarilyLocked: 'Cuenta bloqueada temporalmente. Inténtalo de nuevo en unos instantes.',
   LoginTemporarilyUnavailable: 'Inicio de sesión temporalmente no disponible.',
   InvalidEmailOrPassword: 'Correo o contraseña inválidos.',
   OperationFailed: 'No fue posible completar la operación.',
   RewardUnavailable: 'Producto no disponible para canje.',
   NotEnoughPoints: 'Puntos insuficientes para canjear.',
   RedemptionCannotCancel: 'El canje no está disponible para cancelación.',
   OperationSuccessful: 'Operación realizada con éxito.',
   TooManyAttempts: 'Demasiados intentos. Inténtalo de nuevo en unos instantes.',
   RegistrationTemporarilyUnavailable: 'Registro temporalmente no disponible.',
   CouldNotCreateAccount: 'No fue posible crear la cuenta.',
   ConfirmYourEmail: 'Confirma tu correo',
   EnterTheCodeThatWasSentTo: 'Enviamos un correo a {0}. Confírmalo para activar tu cuenta.',
   ResendCode: 'Reenviar correo',
   ResendCodeTime: 'Reenviar en {0}s',
   Resending: 'Reenviando...',
   ResendEmailFailed: 'No fue posible reenviar el correo.',
   ConfirmingEmail: 'Confirmando correo',
   ConfirmingEmailWait: 'Estamos confirmando tu correo, espera...',
   EmailConfirmed: 'Correo confirmado',
   EmailConfirmedMessage: 'Tu cuenta está activa. Inicia sesión para continuar.',
   EmailConfirmFailed: 'No fue posible confirmar el correo',
   EmailConfirmLinkInvalid: 'El enlace de confirmación es inválido o expiró.',
   Back: 'Volver',
   PasswordResetTitle: 'Restablecer contraseña',
   PasswordResetInstruct: 'Ingresa tu nueva contraseña.',
   PasswordChanged: 'Contraseña actualizada',
   PasswordChangedMessage: 'Tu contraseña fue restablecida. Inicia sesión para continuar.',
   PasswordChangeFailed: 'No fue posible cambiar la contraseña',
   PasswordResetLinkInvalid: 'El enlace de restablecimiento es inválido o expiró.',
   SaveNewPassword: 'Guardar nueva contraseña',
   ChangeMadeSuccessfully: 'Cambio realizado con éxito.',
   TryAgain: 'Inténtalo de nuevo.',
   CouldNotLoadData: 'No fue posible cargar los datos.',
   FullNameInvalid: 'Ingresa nombre y apellido.',
   PhoneNumberInvalid: 'Celular inválido.',
   DocumentInvalid: 'CPF o CNPJ inválido.',
   CropPhoto: 'Ajustar foto',
   CropPhotoHint: 'Mueve y ajusta el área de la foto.',
   Cancel: 'Cancelar',
   Apply: 'Aplicar',
   ErrorLoadingImage: 'No fue posible cargar la imagen.',
   ImageTooLarge: 'La imagen debe tener como máximo 4 MB.',
   InvalidImageType: 'Selecciona un archivo de imagen válido.',
   InstallApp: 'Instalar aplicación',
   InstallAppHint: 'Entra más rápido, directo desde la pantalla de inicio.',
   Install: 'Instalar',
   NotNow: 'Ahora no',
   AddToHomeScreen: 'Ya lo agregué a la pantalla de inicio',
   InstallIosHint: 'En Safari, toca Compartir y luego Agregar a pantalla de inicio.',
};

const DICTS: Record<string, Record<string, string>> = { pt: PT, en: EN, es: ES };

@Injectable({ providedIn: 'root' })
export class I18nService {
   readonly translationsVersion = signal(0);
   private currentLanguage = new Language();
   private translationPage: Record<string, string> = PT;
   private languages: Language[] = [
      { Key: 'pt', Name: 'Português', Country: 'Brazil', FlagIcon: 'br', LocaleCode: 'pt-BR' },
      { Key: 'en', Name: 'English', Country: 'United States', FlagIcon: 'us', LocaleCode: 'en-US' },
      { Key: 'es', Name: 'Español', Country: 'Spain', FlagIcon: 'es', LocaleCode: 'es-ES' },
   ];

   private userService = inject(UserService);

   constructor() {
      this.currentLanguage = this.userService.getLanguage();
      this.fetch(this.currentLanguage.Key);
   }

   getLanguages(): Language[] {
      return this.languages;
   }

   getCurrentLanguage(): Language {
      return this.currentLanguage;
   }

   setCurrentLanguage(language: Language): void {
      this.userService.setLanguage(language);
      this.currentLanguage = language;
      this.fetch(language.Key);
   }

   getTranslation(phrase: string, params?: string[]): string {
      if (!phrase) {
         return '';
      }

      let translatedText = this.translationPage[phrase] ?? phrase;
      if (params?.length) {
         params.forEach((param, index) => {
            translatedText = translatedText.replace(`{${index}}`, param ?? '');
         });
      }
      return translatedText;
   }

   private fetch(languageCode: string): void {
      this.translationPage = DICTS[languageCode] ?? PT;
      this.translationsVersion.update((v) => v + 1);
   }
}
